import React, { PropTypes } from 'react';
import { bibBriefShape, childrenShape } from '@bibliocommons/bc-prop-types';
import BibBrief from '@bibliocommons/shared-bib-brief';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

export default class BorrowingBibBrief extends BcReactComponent {
  render() {
    const { bib, fallbackTitle, children } = this.props;

    return (
      <div className="cp-borrowing-bib-brief">
        <BibBrief
          renderAuthorsAsLink={!this.context.mobileApp}
          bib={bib}
          fallbackTitle={fallbackTitle}
          renderTitleAsLink={!!(bib && bib.get('id'))}>
          {children}
        </BibBrief>
      </div>
    );
  }
}

BorrowingBibBrief.propTypes = {
  bib: bibBriefShape,
  fallbackTitle: PropTypes.string,
  children: childrenShape
};

BorrowingBibBrief.contextTypes = {
  mobileApp: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingBibBrief/BorrowingBibBrief.jsx